import {} from "multitool-sdk-core";
import { fetchAPI } from "./API.js";
import { MultitoolBrowser } from "./MultitoolBrowser.js";
export const bucket = "tasks.multitool.xyz";
const PATH = `/file`;
export class APIStorageAdapter {
    async readBinary(downloadURL) {
        try {
            const downloadResponse = await fetch(downloadURL, {
                method: "GET",
            });
            console.log(`Downloaded File ID ${downloadURL}`);
            return await downloadResponse.blob();
        }
        catch (error) {
            console.error("Error downloading file:", error);
            throw error;
        }
    }
    async readJSON(downloadURL) {
        try {
            const downloadResponse = await fetch(downloadURL, {
                method: "GET",
            });
            console.log(`Downloaded File ID ${downloadURL}`);
            return await downloadResponse.json();
        }
        catch (error) {
            console.error("Error downloading file:", error);
            throw error;
        }
    }
    async writeBinary({ body }) {
        try {
            const response = await fetchAPI(PATH, {
                user: MultitoolBrowser.INSTANCE.user,
                env: MultitoolBrowser.INSTANCE.env,
            }, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
            });
            const { uploadURL, id } = await response.json();
            await fetch(uploadURL, {
                method: "PUT",
                body,
                headers: {
                    "Content-Type": body.type,
                },
            });
            console.log(`Uploaded File ID ${id}`);
            return { id: `${MultitoolBrowser.INSTANCE.user}/file/${id}` };
        }
        catch (error) {
            console.error("Error uploading file:", error);
            throw error;
        }
    }
    async writeJSON({ body }) {
        try {
            const response = await fetchAPI(PATH, {
                user: MultitoolBrowser.INSTANCE.user,
                env: MultitoolBrowser.INSTANCE.env,
            }, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
            });
            const { uploadURL, id } = await response.json();
            await fetch(uploadURL, {
                method: "PUT",
                body: JSON.stringify(body),
                headers: {
                    "Content-Type": "application/json",
                },
            });
            console.log(`Uploaded File ID ${id}`);
            return { id: `${MultitoolBrowser.INSTANCE.user}/file/${id}` };
        }
        catch (error) {
            console.error("Error uploading json file:", error);
            throw error;
        }
    }
}
//# sourceMappingURL=APIStorageAdapter.js.map